$(document).ready(function() {
    $('.announcement-scroller').slick({
        arrows: true,
        autoplay: true,
        adaptiveHeight: false,
        autoplaySpeed: 5000,
        fade: true
    });

    var globalE = $('.announcement-bar');
    var newBanner = $('.scrollerContainer');
    var cname = "localization";
    //var cname = "GlobalE_Data";
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            var cookie = c.substring(name.length, c.length);
        }
    }
    cookie = cookie.includes("US");
   $(newBanner).removeAttr('style');
    $(newBanner).css('visibility', 'visible');
    $(newBanner).css('height', 'auto');
    $(globalE).remove();  
    if( cookie == true ) {
        $(globalE).remove();
        $(newBanner).removeAttr('style');
        $(newBanner).css('visibility', 'visible');
        $(newBanner).css('height', 'auto'); 
    }else{
      $('.product-form__subscription-choice').remove();
    }
});